import type { UINotification } from '../types'
import { useNuxtApp, useState } from '#app'
import { computed } from '#imports'

export const useNotifications = () => {
    const nuxtApp = useNuxtApp()
    const notifications = useState<UINotification[]>('notifications', () => [])

    const preparedNotifications = computed(() => notifications.value.slice(0, 2))

    function add(notification: Omit<UINotification, 'id'>) {
        // Only add once on either server or client
        if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return

        // Notification can only have 1 entry
        if (!notification.multiple && notifications.value.find(current => current.type === notification.type)) return

        notifications.value.push({ ...notification, id: crypto.randomUUID() })
    }

    function remove(id: string) {
        // Only remove once on either server or client
        if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return

        const index = notifications.value.findIndex(notification => notification.id === id)
        if (index === -1) return

        notifications.value.splice(index, 1)
    }

    function clearNotificationsOnPageChange() {
        notifications.value = notifications.value.filter(notification => !notification.clearOnPageChange)
    }

    return {
        /**
         * A list of 0-2 UINotifcation objects.
         */
        notifications: preparedNotifications,
        add,
        remove,
        clearNotificationsOnPageChange,
    }
}
